import * as React from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import {
  BulkUpdateStatusInput,
  BulkUpdateStatusForm,
} from '@user/components/xGrid'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { bulkUpdateOppStatus } from '@user/store/opportunity'

export const BulkUpdateOppStatus: React.FC = () => {
  const dispatch = useAppDispatch()

  const validateRows = React.useCallback(
    async (model: BulkUpdateStatusInput) => {
      const response = await dispatch(bulkUpdateOppStatus({ model }))
      if (bulkUpdateOppStatus.fulfilled.match(response))
        return response.payload.model
    },
    [dispatch],
  )

  const onSubmit = React.useCallback(
    async (model: BulkUpdateStatusInput) =>
      void (await dispatch(
        bulkUpdateOppStatus({
          model,
          mode: 'commit',
        }),
      )),
    [dispatch],
  )

  return (
    <BulkUpdateStatusForm
      entityType={ENTITY_TYPES.Opportunity}
      validateRows={validateRows}
      onSubmit={onSubmit}
    />
  )
}
BulkUpdateOppStatus.displayName = 'BulkUpdateOppStatus'
